import React from "react"
import { Card, Col, Row, CardBody, CardTitle, Container } from "reactstrap"

import { Link, useNavigate } from "react-router-dom"
import { checkExtension } from "helpers/common"
import pdfIcon from "../../assets/images/icons/file-type.svg"
import imageIcon from "../../assets/images/icons/image.svg"
import useFetchKycData from "hooks/useFetchKycData"
import FullPageLoader from "components/fullPageLoader"
import Breadcrumb from "components/Common/Breadcrumb"
import { businessFiles } from "helpers/utils"

const KycDocuments = () => {
  const { kycData, isLoading, user } = useFetchKycData()

  return (
    <div className="page-content">
      <Container fluid>
        {isLoading && <FullPageLoader />}

        <Breadcrumb title={"KYC Documents"} />
        {!isLoading && user?.status === "APPROVED" && kycData && (
          <div>
            <Card>
              <CardBody>
                <Row>
                  <Col xl={12}>
                    {kycData?.entity_type === "COMPANY" && (
                      <>
                        <CardTitle
                          className="mt-4 mb-4"
                          style={{ fontSize: "14px" }}
                        >
                          Entity Documents
                        </CardTitle>
                        <div className="documents-section">
                          {kycData?.investorCompanyDetails?.pan_image && (
                            <div className="documents-box">
                              <div className="file-type">
                                {checkExtension(
                                  kycData?.investorCompanyDetails.pan_image_url
                                ) === "pdf" ? (
                                  <img src={pdfIcon} alt="" />
                                ) : (
                                  <img src={imageIcon} alt="" />
                                )}

                                <div>
                                  <p>PAN</p>
                                  <Link
                                    to={
                                      kycData?.investorCompanyDetails
                                        .pan_image_url
                                    }
                                    target="_blank"
                                  >
                                    <span className="text-small text-success cursor-pointer">
                                      View
                                    </span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          )}
                          {businessFiles.map((item, index) => (
                            <React.Fragment key={`businessFiles_${index}`}>
                              {kycData?.businessAdditionalDetails?.[
                                item.key
                              ] && (
                                <div className="documents-box">
                                  <div className="file-type">
                                    {checkExtension(
                                      kycData?.businessAdditionalDetails?.[
                                        item.key
                                      ]
                                    ) === "pdf" ? (
                                      <img src={pdfIcon} alt="" />
                                    ) : (
                                      <img src={imageIcon} alt="" />
                                    )}

                                    <div>
                                      <p>{item.label}</p>
                                      <Link
                                        to={
                                          kycData?.businessAdditionalDetails?.[
                                            `${item.key}_url`
                                          ]
                                        }
                                        target="_blank"
                                      >
                                        <span className="text-small text-success cursor-pointer">
                                          View
                                        </span>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </React.Fragment>
                          ))}
                        </div>

                        <hr className="my-4" />
                      </>
                    )}
                    <CardTitle
                      className="mt-4 mb-4"
                      style={{ fontSize: "14px" }}
                    >
                      Authorised Person Documents
                    </CardTitle>
                    <div className="documents-section">
                      {kycData?.investorsAadhaar?.aadhaar_file && (
                        <div className="documents-box">
                          <div className="file-type">
                            {checkExtension(
                              kycData?.investorsAadhaar.aadhaar_file_url
                            ) === "pdf" ? (
                              <img src={pdfIcon} alt="" />
                            ) : (
                              <img src={imageIcon} alt="" />
                            )}

                            <div>
                              <p>Aadhaar</p>
                              <Link
                                to={kycData?.investorsAadhaar.aadhaar_file_url}
                                target="_blank"
                              >
                                <span className="text-small text-success cursor-pointer">
                                  View
                                </span>
                              </Link>
                            </div>
                          </div>
                          {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                        </div>
                      )}
                      {kycData?.avatar_url && (
                        <div className="documents-box">
                          <div className="file-type">
                            {checkExtension(kycData?.avatar_url) === "pdf" ? (
                              <img src={pdfIcon} alt="" />
                            ) : (
                              <img src={imageIcon} alt="" />
                            )}

                            <div>
                              <p>Selfie</p>
                              <Link to={kycData?.avatar_url} target="_blank">
                                <span className="text-small text-success cursor-pointer">
                                  View
                                </span>
                              </Link>
                            </div>
                          </div>
                          {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                        </div>
                      )}
                      {kycData?.investorsPAN?.pan_file && (
                        <div className="documents-box">
                          <div className="file-type">
                            {checkExtension(
                              kycData?.investorsPAN?.pan_file_url
                            ) === "pdf" ? (
                              <img src={pdfIcon} alt="" />
                            ) : (
                              <img src={imageIcon} alt="" />
                            )}

                            <div>
                              <p>PAN</p>
                              <Link
                                to={kycData?.investorsPAN?.pan_file_url}
                                target="_blank"
                              >
                                <span className="text-small text-success cursor-pointer">
                                  View
                                </span>
                              </Link>
                            </div>
                          </div>
                          {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                        </div>
                      )}

                      {kycData?.businessAdditionalDetails?.authority_letter && (
                        <div className="documents-box">
                          <div className="file-type">
                            {checkExtension(
                              kycData?.businessAdditionalDetails
                                ?.authority_letter_url
                            ) === "pdf" ? (
                              <img src={pdfIcon} alt="" />
                            ) : (
                              <img src={imageIcon} alt="" />
                            )}

                            <div>
                              <p>Authority Letter</p>
                              <Link
                                to={
                                  kycData?.businessAdditionalDetails
                                    ?.authority_letter_url
                                }
                                target="_blank"
                              >
                                <span className="text-small text-success cursor-pointer">
                                  View
                                </span>
                              </Link>
                            </div>
                          </div>
                          {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                        </div>
                      )}
                    </div>

                    <hr className="my-4" />
                    <CardTitle
                      className="mt-4 mb-4"
                      style={{ fontSize: "14px" }}
                    >
                      Banking Documents
                    </CardTitle>
                    <div className="documents-section">
                      {kycData?.investorsBankDetails?.cheque_file && (
                        <div className="documents-box">
                          <div className="file-type">
                            {checkExtension(
                              kycData?.investorsBankDetails.cheque_file_url
                            ) === "pdf" ? (
                              <img src={pdfIcon} alt="" />
                            ) : (
                              <img src={imageIcon} alt="" />
                            )}

                            <div>
                              <p>Cheque</p>
                              <Link
                                to={
                                  kycData?.investorsBankDetails.cheque_file_url
                                }
                                target="_blank"
                              >
                                <span className="text-small text-success cursor-pointer">
                                  View
                                </span>
                              </Link>
                            </div>
                          </div>
                          {/* <div className="verified-user">
                      <img src={check} alt="" /> Verified
                    </div> */}
                        </div>
                      )}
                    </div>

                    {/* {kycData?.icdAgreements &&
                  kycData?.icdAgreements.length > 0 && (
                    <>
                      <hr className="my-4" />
                      <CardTitle
                        className="mt-4 mb-4"
                        style={{ fontSize: "14px" }}
                      >
                        Executed Documents
                      </CardTitle>
                      <div className="documents-section">
                        {kycData?.icdAgreements.map((doc, index) => (
                          <div className="documents-box" key={`docs_${index}`}>
                            <div className="file-type">
                              <img src={pdfIcon} alt="" />

                              <div>
                                <p>
                                  {doc.doc_type === "TERM_SHEET"
                                    ? "ICD Schedule Terms"
                                    : "ICD Framework Agreement"}
                                </p>
                                <Link to={doc.doc_url} target="_blank">
                                  <span className="text-small text-success cursor-pointer">
                                    View
                                  </span>
                                </Link>
                              </div>
                              <p></p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )} */}
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        )}
      </Container>
    </div>
  )
}

export default KycDocuments
